import * as PropTypes from "prop-types";

export default PropTypes.objectOf(PropTypes.shape({
  name: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  requiresZip: PropTypes.bool.isRequired,
  requiresState: PropTypes.bool.isRequired,
  supportsStripe: PropTypes.bool.isRequired,
  shippingPrices: PropTypes.shape({
    standard: PropTypes.number.isRequired,
    expedited: PropTypes.number.isRequired
  }).isRequired
}));